import { api } from "@/core/api/";

const apiUrl = "api/alert";

export default {
    get(route, params) {
        return api.get(`${apiUrl}/${route}`, {
            params: {
                ...params
            }
        });
    },
    getAlertType() {
        return api.get(`${apiUrl}/types`);
    },
    getAlertSubType(params) {
        return this.get('subtypes', params);
    },
}
